<template>
    <div class="contents">
        <!-- Scalev Integration Warning Modal (auto-show for monthly packages) -->
        <div v-if="showScalevWarning" class="scalev-modal-backdrop">
            <div class="scalev-modal-content">
                <div class="scalev-modal-header">
                    <i class="fas fa-exclamation-triangle text-warning"></i>
                    <h5 class="mb-0 ml-2">Perhatian: Integrasi Scalev</h5>
                </div>
                <div class="scalev-modal-body">
                    <p class="mb-2">
                        Paket yang Kakak pilih adalah <strong>Paket Bulanan</strong>.
                    </p>
                    <div class="alert alert-warning mb-3" role="alert">
                        <i class="fas fa-info-circle mr-2"></i>
                        Untuk dapat menggunakan <strong>Integrasi ke Scalev</strong>, mohon gunakan
                        <strong>Paket minimal 6 Bulan atau 1 Tahun</strong>.
                    </div>
                    <p class="mb-2">
                        Jika Kakak melanjutkan pembelian paket bulanan ini, artinya Kakak
                        <strong>setuju tidak menggunakan fitur Integrasi ke Scalev</strong>.
                    </p>
                    <p class="mb-0 text-muted">
                        Jika Kakak butuh Integrasi ke Scalev, silakan kembali dan pilih
                        Paket 6 Bulan atau 1 Tahun.
                    </p>
                </div>
                <div class="scalev-modal-footer">
                    <button type="button" class="btn btn-outline-secondary" @click="continueBuyMonthly">
                        Saya Tetap Beli Bulanan (Tanpa Scalev)
                    </button>
                    <button type="button" class="btn btn-primary" @click="goBackToPackageList">
                        <i class="fas fa-arrow-left mr-1"></i>Pilih Paket 6 Bulan / 1 Tahun
                    </button>
                </div>
            </div>
        </div>

        <!-- StarQRIS QR Modal -->
        <div v-if="showStarQrisModal" class="scalev-modal-backdrop">
            <div class="scalev-modal-content" style="max-width:420px">
                <div class="scalev-modal-header">
                    <i class="fas fa-qrcode text-primary"></i>
                    <h5 class="mb-0 ml-2">Bayar via StarQRIS</h5>
                </div>
                <div class="scalev-modal-body">
                    <StarQrisPayment
                        :transactionId="starqrisTransactionId"
                        :data="starqrisPayment"
                        @paid="onStarQrisPaid"
                        @done="onStarQrisDone"
                        @cancel="closeStarQrisModal"
                    />
                </div>
            </div>
        </div>

        <div class="crm">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-12 mb-4">
          <div class="product-card card shadow-sm">
            <div class="card-body">
              <div class="product-header d-flex align-items-center mb-3">
                <div>
                  <h5 class="card-title mb-1">{{ packages.name }}</h5>
                  <p class="text-muted mb-0">{{ packages.duration }} Hari</p>
                </div>
              </div>
              <div class="product-details">
                <div class="row">
                  <div class="col-sm-6">
                    <p><strong>Harga:</strong> {{ formatRupiah(packages.price) }}</p>
                  </div>
                  <div class="col-sm-6">
                    <p><strong>Quantity:</strong> 1</p>
                  </div>
                </div>
              </div>
              <div v-if="packages.webhook_media_quota > 0" class="device-selection mt-4">
                <p class="text-muted small mb-2">
                  Quota Webhook Media berlaku <strong>1 bulan</strong> sejak pembayaran sukses, terpisah dari masa aktif paket StarSender. Setelah habis, beli ulang add-on untuk device yang sama.
                </p>
                <h6><i data-feather="smartphone" class="mr-2"></i>Pilih Device</h6>
                <multiselect
                  v-model="objek_device"
                  placeholder="Pilih device"
                  :custom-label="nameWithHP"
                  label="nama"
                  track-by="id"
                  :options="device"
                  :multiple="false"
                  class="mt-2"
                ></multiselect>
              </div>
            </div>
          </div>

          <!-- Manual transfer form (shown when user picks it) -->
          <div v-if="showManualForm" class="card shadow-sm mt-3">
            <div class="card-body">
              <h5 class="mb-3"><i class="fas fa-university"></i> Bayar via Transfer Manual</h5>
              <ManualTransferForm
                :paymentMode="paymentModeForPackage"
                :amount="total"
                :targetId="parseInt(packages.id) || 0"
                :targetLabel="packages.name || ''"
                @cancel="showManualForm = false"
                @success="onManualSuccess"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="order-summary card shadow-sm">
            <div class="card-header bg-primary text-white">
              <h5 class="mb-0 text-white">
                Ringkasan Order
              </h5>
            </div>
            <div class="card-body">
              <div class="summary-item d-flex justify-content-between mb-2">
                <span>Subtotal:</span>
                <span>{{ formatRupiah(packages.price) }}</span>
              </div>
              <div class="summary-item d-flex justify-content-between mb-3">
                <span>Discount:</span>
                <span id="discount">{{ formatRupiah(coupon.discount) }}</span>
              </div>
              <hr />
              <div class="coupon-section mb-3">
                <label for="coupon-code">
                  <i data-feather="tag" class="mr-1"></i>Kode Kupon:
                </label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="coupon.code"
                    id="coupon-code"
                    placeholder="Masukkan kode kupon"
                  />
                  <div class="input-group-append">
                    <button v-on:click="checkCouponCode" class="btn btn-outline-primary">
                      Apply
                    </button>
                  </div>
                </div>
                <div class="coupon-message mt-2">
                  <small v-if="coupon.status == 'loading'" class="text-primary">
                    <i data-feather="loader" class="spin mr-1"></i>Memverifikasi Kode Kupon...
                  </small>
                  <small v-else-if="coupon.status == 'invalid'" class="text-danger">
                    <i data-feather="x" class="mr-1"></i>{{ coupon.message }}
                  </small>
                  <small v-else-if="coupon.status == 'valid'" class="text-success">
                    <i data-feather="check" class="mr-1"></i>{{ coupon.message }}
                  </small>
                </div>
              </div>
              <hr />
              <div class="total-section mb-3">
                <div class="d-flex justify-content-between">
                  <strong>Total:</strong>
                  <strong id="total-final" class="text-primary">{{ formatRupiah(total) }}</strong>
                </div>
              </div>
              <div class="balance-section mb-3">
                <div class="d-flex justify-content-between">
                  <span>Saldo Anda:</span>
                  <span>{{ formatRupiah(user_balance) }}</span>
                </div>
              </div>
              <button
                v-if="user_balance >= total && !showManualForm && !showStarQrisModal"
                v-on:click="buyPackage"
                id="btn-bayar"
                class="btn btn-success btn-block btn-lg"
              >
                <i class="las la-arrow-right mr-2"></i>Bayar via Saldo
              </button>
              <button v-if="user_balance < total && !showManualForm && !showStarQrisModal" class="btn btn-secondary btn-block btn-lg" disabled>
                <i class="las la-times mr-2"></i>Saldo Tidak Cukup
              </button>

              <!-- Bayar Langsung (Tripay — hanya jika enabled di Payment Setting) -->
              <div v-if="canDirect && !showManualForm && !showStarQrisModal" class="direct-pay mt-3">
                <div class="direct-divider"><span>{{ user_balance >= total ? 'atau bayar langsung' : 'bayar langsung tanpa top up' }}</span></div>
                <p class="direct-hint"><i class="fas fa-bolt"></i> Bayar pas <b>{{ formatRupiah(total) }}</b> lewat Bank / QRIS — paket langsung aktif otomatis, tanpa perlu top up saldo dulu.</p>
                <div v-if="channels.length">
                  <div v-for="grp in groupedChannels" :key="grp.group" class="ch-group">
                    <div class="ch-group-title">{{ grp.group }}</div>
                    <div class="ch-grid">
                      <button v-for="ch in grp.items" :key="ch.channel_code" type="button"
                        class="ch-card" :style="'--accent:' + (ch.class || '#5F63F2')"
                        @click="payDirect(ch.channel_code)" :disabled="directLoading">
                        <span class="ch-logo" :class="{ 'no-img': imgErr[ch.channel_code] }">
                          <img :src="channelIcon(ch.channel_code)" :alt="ch.channel_name" @error="onImgError(ch.channel_code)">
                          <i class="fas fa-university"></i>
                        </span>
                        <span class="ch-name">{{ ch.channel_name }}</span>
                        <i class="fas fa-chevron-right ch-arrow"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else class="text-muted small text-center py-2"><i class="fas fa-spinner fa-spin"></i> Memuat metode pembayaran...</div>
              </div>

              <!-- StarQRIS -->
              <div v-if="canStarQris && !showManualForm && !showStarQrisModal" class="mt-3">
                <div v-if="user_balance >= total || !canDirect" class="direct-divider"><span>{{ user_balance >= total ? 'atau bayar langsung' : 'bayar langsung tanpa top up' }}</span></div>
                <button type="button" class="ch-card starqris-card" style="--accent:#00b894;width:100%"
                    @click="payStarQris" :disabled="starqrisLoading">
                    <span class="ch-logo no-img"><i class="fas fa-qrcode"></i></span>
                    <span class="ch-name">QRIS via StarQRIS<span class="ch-desc">Scan QR, paket aktif otomatis</span></span>
                    <i class="fas fa-chevron-right ch-arrow"></i>
                </button>
              </div>

              <!-- Manual transfer button (only show if enabled & form not open yet) -->
              <button
                v-if="paymentMethods.manual_transfer_enabled && !showManualForm && !showStarQrisModal"
                v-on:click="openManualTransfer"
                class="btn btn-warning btn-block btn-lg mt-2">
                <i class="fas fa-university mr-2"></i>Bayar Transfer Manual
              </button>
              <small v-if="paymentMethods.manual_transfer_enabled && !showManualForm && !showStarQrisModal" class="text-muted d-block mt-1 text-center">
                Transfer ke rekening admin → upload bukti → admin verify
              </small>

              <div v-if="!hasAnyPaymentMethod && !showManualForm && !showStarQrisModal" class="alert alert-warning mt-3 mb-0">
                Tidak ada metode pembayaran tersedia saat ini. Silakan hubungi admin.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import ManualTransferForm from '@/components/forms/billing/ManualTransferForm.vue'
    import StarQrisPayment from '@/components/forms/billing/StarQrisPayment.vue'
    export default {
        components: {
            Multiselect,
            ManualTransferForm,
            StarQrisPayment,
        },
        data() {
            return {
                isLoading: true,
                packages: {},
                user_balance: 0,
                discount: 0,
                total: 0,
                coupon: {
                    status: "",
                    message: "",
                    code: "",
                    data: {},
                    discount: 0,
                },
                device: [],
                objek_device: null,
                paymentMethods: { tripay_enabled: true, manual_transfer_enabled: false, starqris_enabled: false, banks: [] },
                showManualForm: false,
                showScalevWarning: false,
                showStarQrisModal: false,
                starqrisPayment: {},
                starqrisTransactionId: '',
                starqrisLoading: false,
                channels: [],
                imgErr: {},
                directLoading: false,
            };
        },
        computed: {
            canDirect() {
                const t = parseInt(this.total) || 0;
                return this.paymentMethods.tripay_enabled && t >= 10000 && t <= 10000000;
            },
            canStarQris() {
                const t = parseInt(this.total) || 0;
                return this.paymentMethods.starqris_enabled && t >= 10000 && t <= 10000000;
            },
            hasAnyPaymentMethod() {
                return this.paymentMethods.tripay_enabled
                    || this.paymentMethods.manual_transfer_enabled
                    || this.paymentMethods.starqris_enabled;
            },
            groupedChannels() {
                const groups = {};
                (this.channels || []).forEach(ch => {
                    const g = ch.group || 'Lainnya';
                    (groups[g] = groups[g] || []).push(ch);
                });
                const order = ['Virtual Account', 'E-Wallet', 'Convenience Store'];
                const rank = (x) => (order.indexOf(x) < 0 ? 99 : order.indexOf(x));
                return Object.keys(groups).sort((a, b) => rank(a) - rank(b)).map(g => ({ group: this.groupLabel(g), items: groups[g] }));
            },
            paymentModeForPackage() {
                // Distinguish addon vs main package
                if (this.packages && this.packages.is_addon == 1) return 'addon';
                return 'buy_package';
            },
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        async mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            let id = this.$route.params.id
            await this.fetchPackage(id)
            await this.fetchUser()
            await this.countTotal()
            await this.fetchPaymentMethods()
            if(this.packages.webhook_media_quota > 0){
                await this.getDevice()
            }
            // Show Scalev integration warning for monthly packages (duration <= 31 days)
            // Skip warning for addon packages (they follow main package duration)
            if (this.packages && this.packages.is_addon != 1 && this.packages.duration && parseInt(this.packages.duration) <= 31) {
                this.showScalevWarning = true
            }
        },
        methods: {
            async fetchChannels() {
                if (!this.paymentMethods.tripay_enabled) {
                    this.channels = [];
                    return;
                }
                try {
                    let r = await this.$store.dispatch('payment_channel');
                    this.channels = (r.data && r.data.data && r.data.data.payment_channel) ? r.data.data.payment_channel : [];
                } catch (e) { this.channels = []; }
            },
            channelIcon(code) {
                const map = {
                    PERMATAVA: 'https://assets.tripay.co.id/upload/payment-icon/szezRhAALB1583408731.png',
                    BNIVA: 'https://assets.tripay.co.id/upload/payment-icon/n22Qsh8jMa1583433577.png',
                    BRIVA: 'https://assets.tripay.co.id/upload/payment-icon/8WQ3APST5s1579461828.png',
                    MANDIRIVA: 'https://assets.tripay.co.id/upload/payment-icon/T9Z012UE331583531536.png',
                    BCAVA: 'https://assets.tripay.co.id/upload/payment-icon/ytBKvaleGy1605201833.png',
                    MUAMALATVA: 'https://assets.tripay.co.id/upload/payment-icon/GGwwcgdYaG1611929720.png',
                    CIMBVA: 'https://assets.tripay.co.id/upload/payment-icon/WtEJwfuphn1614003973.png',
                    BSIVA: 'https://assets.tripay.co.id/upload/payment-icon/tEclz5Assb1643375216.png',
                    DANAMONVA: 'https://assets.tripay.co.id/upload/payment-icon/F3pGzDOLUz1644245546.png',
                    ALFAMART: 'https://assets.tripay.co.id/upload/payment-icon/jiGZMKp2RD1583433506.png',
                    INDOMARET: 'https://assets.tripay.co.id/upload/payment-icon/zNzuO5AuLw1583513974.png',
                    ALFAMIDI: 'https://assets.tripay.co.id/upload/payment-icon/aQTdaUC2GO1593660384.png',
                    QRIS: 'https://assets.tripay.co.id/upload/payment-icon/BpE4BPVyIw1605597490.png',
                    QRIS2: 'https://assets.tripay.co.id/upload/payment-icon/8ewGzP6SWe1649667701.png',
                };
                return map[code] || '';
            },
            groupLabel(g) {
                return ({ 'Virtual Account': 'Transfer Bank (Virtual Account)', 'E-Wallet': 'QRIS / E-Wallet', 'Convenience Store': 'Minimarket / Retail' })[g] || g;
            },
            onImgError(code) { this.$set(this.imgErr, code, true); },
            async payDirect(code) {
                if (!this.paymentMethods.tripay_enabled) {
                    this.$toast.warning("Pembayaran Tripay sedang nonaktif. Gunakan Transfer Manual.");
                    return;
                }
                if (this.packages.webhook_media_quota > 0 && !this.objek_device) {
                    this.$toast.error("Harap pilih device terlebih dahulu"); return;
                }
                const amount = parseInt(this.total) || 0;
                if (amount < 10000) { this.$toast.error("Nominal terlalu kecil untuk pembayaran langsung"); return; }
                this.directLoading = true;
                const intent = {
                    package_id: parseInt(this.$route.params.id),
                    code: this.coupon.code || "",
                    id_device: this.objek_device ? parseInt(this.objek_device.id) : null,
                    amount: amount,
                    name: this.packages.name || "",
                    ts: Date.now(),
                };
                try {
                    localStorage.setItem("ss_pending_buy", JSON.stringify(intent));
                    const r = await this.$store.dispatch("payment_topup", { nominal: amount, payment_channel: code, buy_package_id: parseInt(this.$route.params.id) });
                    window.location.replace(r.data.data.transaction.checkout_url);
                } catch (err) {
                    this.directLoading = false;
                    try { localStorage.removeItem("ss_pending_buy"); } catch (e) { /* noop */ }
                    this.$toast.error(err.response?.data?.message || "Gagal membuat pembayaran");
                }
            },
            nameWithHP ({ name, no_hp }) {
                return `${name} (${no_hp})`
            },
            async fetchPaymentMethods() {
                try {
                    const r = await axios.get('payment/methods')
                    if (r.data && r.data.success) {
                        this.paymentMethods = r.data.data
                    }
                } catch (err) {
                    // silent
                }
                await this.fetchChannels()
            },
            openManualTransfer() {
                this.showManualForm = true
            },
            continueBuyMonthly() {
                this.showScalevWarning = false
            },
            goBackToPackageList() {
                this.showScalevWarning = false
                this.$router.push("/billing")
            },
            onManualSuccess() {
                this.showManualForm = false
                this.$toast.success("Konfirmasi terkirim, menunggu verifikasi admin")
                this.$router.push("/billing/manual-payments")
            },
            async payStarQris() {
                if (!this.paymentMethods.starqris_enabled) {
                    this.$toast.warning("Pembayaran StarQRIS sedang nonaktif.")
                    return
                }
                if (this.packages.webhook_media_quota > 0 && !this.objek_device) {
                    this.$toast.error("Harap pilih device terlebih dahulu")
                    return
                }
                const amount = parseInt(this.total) || 0
                if (amount < 10000) {
                    this.$toast.error("Nominal terlalu kecil untuk StarQRIS")
                    return
                }
                if (amount > 10000000) {
                    this.$toast.error("Nominal terlalu besar untuk StarQRIS")
                    return
                }

                const intent = {
                    package_id: parseInt(this.$route.params.id),
                    code: this.coupon.code || "",
                    id_device: this.objek_device ? parseInt(this.objek_device.id) : null,
                    amount: amount,
                    name: this.packages.name || "",
                    ts: Date.now(),
                }
                try {
                    localStorage.setItem("ss_pending_buy", JSON.stringify(intent))
                } catch (e) { /* noop */ }

                this.starqrisLoading = true
                try {
                    const r = await this.$store.dispatch("payment_topup", {
                        nominal: amount,
                        payment_channel: "starqris",
                        buy_package_id: parseInt(this.$route.params.id),
                    })
                    const data = r.data && r.data.data ? r.data.data : {}
                    const trx = data.transaction || {}
                    if (!data.starqris) {
                        throw new Error("Data QRIS tidak diterima dari server. Silakan coba lagi.")
                    }
                    this.starqrisTransactionId = trx.transaction_id || trx.TransactionID || ""
                    this.starqrisPayment = data.starqris
                    this.showStarQrisModal = true
                } catch (err) {
                    try { localStorage.removeItem("ss_pending_buy") } catch (e) { /* noop */ }
                    this.$toast.error(err.response?.data?.message || err.message || "Gagal membuat pembayaran StarQRIS")
                } finally {
                    this.starqrisLoading = false
                }
            },
            closeStarQrisModal() {
                this.showStarQrisModal = false
                this.starqrisPayment = {}
                this.starqrisTransactionId = ""
            },
            async onStarQrisPaid() {
                try {
                    await this.activatePackageAfterPayment()
                    this.$toast.success("Pembayaran berhasil — paket Anda sudah AKTIF!")
                } catch (e) {
                    this.$toast.warning("Pembayaran berhasil. Saldo sudah masuk — silakan klik Bayar via Saldo untuk mengaktifkan paket.")
                }
            },
            async onStarQrisDone() {
                this.closeStarQrisModal()
                try { localStorage.removeItem("ss_pending_buy") } catch (e) { /* noop */ }
                this.$router.push("/billing")
            },
            async activatePackageAfterPayment() {
                let raw = null
                try { raw = localStorage.getItem("ss_pending_buy") } catch (e) { return }
                if (!raw) return
                let intent
                try { intent = JSON.parse(raw) } catch (e) { return }

                for (let i = 0; i < 15; i++) {
                    let bal = 0
                    try {
                        const u = await this.$store.dispatch("user_detail")
                        bal = parseInt(u.data.data.user.balance) || 0
                        this.user_balance = bal
                    } catch (e) { /* noop */ }
                    if (bal >= (parseInt(intent.amount) || 0)) {
                        const payload = { id: parseInt(intent.package_id), code: intent.code || "" }
                        if (intent.id_device) payload.id_device = parseInt(intent.id_device)
                        await this.$store.dispatch("package_buy", payload)
                        await this.updateUserPackage()
                        try { localStorage.removeItem("ss_pending_buy") } catch (e) { /* noop */ }
                        return
                    }
                    await new Promise(res => setTimeout(res, 2000))
                }
                throw new Error("balance not ready")
            },
            async buyPackage() {
                try {
                    if(this.packages.webhook_media_quota > 0){
                        if(this.objek_device == null){
                            this.$toast.error("Harap pilih device")
                            return
                        }else{
                            await this.$store.dispatch('package_buy', { id: parseInt(this.$route.params.id), code: this.coupon.code, id_device:parseInt(this.objek_device.id) })

                            await this.updateUserPackage()

                            this.$toast.success("Berhasil membeli paket")
                            this.$router.push("/billing")
                        }
                    }else{
                        await this.$store.dispatch('package_buy', { id: parseInt(this.$route.params.id), code: this.coupon.code })

                        await this.updateUserPackage()

                        this.$toast.success("Berhasil membeli paket")
                        this.$router.push("/billing")
                    }
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Gagal membeli paket")
                    this.$router.push("/billing")
                }
            },
            async updateUserPackage() {
                try {
                    let userDetail = await this.$store.dispatch('user_detail')

                    if (userDetail?.data?.data) {
                        if (userDetail.data.data.package_data) {
                            this.$store.commit('auth/SET_PACKAGE', userDetail.data.data.package_data)
                            const exp = userDetail.data.data.package_data.expired_at
                            const expMs = typeof exp === 'number' ? exp : Number(exp)
                            if (Number.isFinite(expMs) && expMs >= Date.now()) {
                                try { sessionStorage.setItem('ss_package_fresh', '1') } catch (e) { /* noop */ }
                            }
                        }

                        if (userDetail.data.data.user) {
                            if (userDetail.data.data.user.balance !== undefined) {
                                this.user_balance = userDetail.data.data.user.balance
                            }
                            if (userDetail.data.data.user) {
                                this.$store.commit('auth/SET_USER', userDetail.data.data.user)
                            }
                        }
                    }
                } catch (err) {
                    console.error('Failed to update user package:', err)
                }
            },
            async fetchUser() {
                try {
                    let user_data = await this.$store.dispatch('user_detail')
                    this.user_balance = user_data.data.data.user.balance
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/billing")
                }
            },
            async fetchPackage(id) {
                this.isLoading = true
                try {
                    let package_detail = await this.$store.dispatch('package_detail', { id: id })
                    this.packages = package_detail.data.data.package
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/billing")
                }
                this.isLoading = false
            },
            formatRupiah(numb) {
                const format = numb?.toString().split('').reverse().join('');
                const convert = format?.match(/\d{1,3}/g);
                const rupiah = 'Rp ' + convert?.join('.').split('').reverse().join('')
                return rupiah
            },
            async getDevice() {
                let res = await this.$store.dispatch("device_list_all", "all");
                this.device = res.data.data.devices
            },
            countTotal(){
                this.total = parseInt(this.packages.price) - parseInt(this.discount)
            },
            async checkCouponCode(){
                this.total = parseInt(this.packages.price)
                this.coupon.status = "loading"
                try {
                    let coupon_detail = await this.$store.dispatch('coupon_check', { code: this.coupon.code })
                    this.coupon.status = "valid"
                    this.coupon.data = coupon_detail.data.data.coupon
                    await this.calculateDiscount()
                } catch (err) {
                    this.coupon.status = "invalid"
                    this.coupon.message = "Kode Kupon Tidak Tersedia"
                }
            },
            calculateDiscount(){
                if(this.coupon.data.mode == 1){
                    this.coupon.discount = this.coupon.data.discount
                }else if(this.coupon.data.mode == 2){
                    this.coupon.discount = (this.total / 100) * this.coupon.data.discount
                }

                this.coupon.message = "Kode Kupon Tersedia, Anda Mendapat Diskon Sebesar " + this.formatRupiah(this.coupon.discount)

                if(this.total - this.coupon.discount <= 0){
                    this.total = 0
                }else{
                    this.total = this.total - this.coupon.discount
                }
            }
        },
    };
</script>

<style scoped>
.contents {
  margin-top: 20px;
}

.page-header {
  margin-bottom: 2rem;
}

.page-title {
  color: #495057;
  font-weight: 600;
}

.product-card {
  border: none;
  border-radius: 15px;
  transition: transform 0.2s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-header .icon-lg {
  font-size: 2rem;
}

.order-summary {
  border: none;
  border-radius: 15px;
  overflow: hidden;
}

.order-summary .card-header {
  background: linear-gradient(135deg, #007bff, #0056b3);
  border: none;
}

.summary-item {
  padding: 0.5rem 0;
}

.coupon-section label {
  font-weight: 500;
  color: #495057;
}

.coupon-message small {
  display: block;
  margin-top: 0.25rem;
}

.total-section strong {
  font-size: 1.25rem;
}

.balance-section {
  background-color: #e9ecef;
  padding: 0.75rem;
  border-radius: 8px;
}

.btn-success {
  background: linear-gradient(135deg, #28a745, #20c997);
  border: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.btn-secondary {
  background-color: #6c757d;
  border: none;
}

.device-selection {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}

.device-selection h6 {
  color: #495057;
  font-weight: 500;
}

/* Icon animations */
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .billing-page {
    padding: 1rem 0;
  }
  .product-card, .order-summary {
    margin-bottom: 1rem;
  }
  .page-title {
    font-size: 1.5rem;
  }
}

/* Scalev Warning Modal */
.scalev-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  animation: fadeIn 0.2s ease;
}

.scalev-modal-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  max-width: 560px;
  width: 100%;
  overflow: hidden;
  animation: slideUp 0.25s ease;
}

.scalev-modal-header {
  display: flex;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #fff8e1, #fffbe6);
}

.scalev-modal-header i {
  font-size: 1.5rem;
}

.scalev-modal-header h5 {
  color: #856404;
  font-weight: 600;
}

.scalev-modal-body {
  padding: 1.5rem;
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.55;
}

.scalev-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  flex-wrap: wrap;
}

.scalev-modal-footer .btn {
  flex: 1 1 auto;
  min-width: 180px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@media (max-width: 576px) {
  .scalev-modal-footer .btn {
    width: 100%;
  }
}

/* Direct pay */
.direct-divider { display:flex; align-items:center; text-align:center; color:#9aa6c0; font-size:12px; font-weight:600; text-transform:uppercase; letter-spacing:.04em; margin:6px 0 12px; }
.direct-divider::before, .direct-divider::after { content:''; flex:1; height:1px; background:#e9ebf6; }
.direct-divider span { padding:0 10px; }
.direct-hint { font-size:12.5px; color:#6b7280; background:#f5f6fd; border:1px solid #e9ebf6; border-radius:8px; padding:9px 11px; margin-bottom:12px; }
.direct-hint .fa-bolt { color:#f5c451; margin-right:4px; }
.ch-group { margin-bottom: 14px; }
.ch-group-title { font-size: 11px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #8b93a7; margin: 0 2px 8px; }
.ch-grid { display: grid; grid-template-columns: 1fr; gap: 9px; }
.ch-card { display:flex; align-items:center; gap:11px; width:100%; text-align:left; background:#fff; border:1.5px solid #e9ebf6; border-radius:11px; padding:10px 12px; cursor:pointer; transition:all .18s ease; position:relative; overflow:hidden; }
.ch-card::before { content:''; position:absolute; left:0; top:0; bottom:0; width:4px; background:var(--accent,#5F63F2); opacity:0; transition:opacity .18s; }
.ch-card:hover:not(:disabled) { border-color:var(--accent,#5F63F2); box-shadow:0 9px 22px -12px rgba(95,99,242,.5); transform:translateY(-2px); }
.ch-card:hover:not(:disabled)::before { opacity:1; }
.ch-card:disabled { opacity:.5; cursor:not-allowed; }
.ch-logo { flex:0 0 auto; width:52px; height:34px; display:flex; align-items:center; justify-content:center; background:#f6f7fc; border:1px solid #eef0f8; border-radius:7px; }
.ch-logo img { max-width:42px; max-height:24px; object-fit:contain; }
.ch-logo i { display:none; color:var(--accent,#5F63F2); font-size:17px; }
.ch-logo.no-img img { display:none; }
.ch-logo.no-img i { display:inline-block; }
.ch-name { flex:1 1 auto; font-weight:600; font-size:13px; color:#2b3042; line-height:1.2; }
.ch-arrow { flex:0 0 auto; color:#c3c8da; font-size:12px; transition:.18s; }
.ch-card:hover:not(:disabled) .ch-arrow { color:var(--accent,#5F63F2); transform:translateX(2px); }
.ch-desc { display:block; font-size:11px; font-weight:400; color:#8b93a7; margin-top:2px; }
.starqris-card .ch-name { display:flex; flex-direction:column; }
</style>
